import { useRef } from "react";

export function useLongPress({ onShortClick, onLongClick, delay = 500 }) {
  const timerRef = useRef(null);

  const start = () => {
    timerRef.current = setTimeout(() => {
      onLongClick();
      timerRef.current = null; // clear after firing long click
    }, delay);
  };

  const clear = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
      onShortClick();
    }
  };

  return {
    onMouseDown: start,
    onMouseUp: clear,
    onMouseLeave: clear,
    onTouchStart: start,
    onTouchEnd: clear,
  };
}
